/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// cSpell:ignore horiz

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
    FlexCol,
    FlexRow,
    VisualOnlyLabel,
    Text,
    Button,
    Stack,
    Icon,
    useFlags,
} from 'sarsaparilla';

export default function Details({
    date,
    endDate,
    startTime,
    endTime,
    validDays,
    onModifyClick,
}) {
    const { ticketAdjustMultiDayTicket } = useFlags();
    const allowMultiDays = useMemo(() => {
        return ticketAdjustMultiDayTicket && !!validDays && validDays > 1;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticketAdjustMultiDayTicket, validDays]);

    return (
        <Stack space="sm">
            <FlexRow>
                {!allowMultiDays && (
                    <>
                        <FlexCol md={4} xs={6}>
                            <VisualOnlyLabel>Date</VisualOnlyLabel>
                            <Text>{date}</Text>
                        </FlexCol>
                        <FlexCol md={4} xs={6}>
                            <VisualOnlyLabel>Start Time</VisualOnlyLabel>
                            <Text>{startTime}</Text>
                        </FlexCol>
                    </>
                )}

                {!!allowMultiDays && (
                    <>
                        <FlexCol md={4} xs={6}>
                            <VisualOnlyLabel>Dates</VisualOnlyLabel>
                            <Text>{`${date} - ${endDate}`}</Text>
                        </FlexCol>
                        <FlexCol md={4} xs={6}>
                            <VisualOnlyLabel>Entry Window</VisualOnlyLabel>
                            <Text>{`${startTime} - ${endTime}`}</Text>
                        </FlexCol>
                    </>
                )}
            </FlexRow>
            <div>
                <Button
                    iconBeforeElement={<Icon iconName="swap-horiz" />}
                    onClick={onModifyClick}
                    appearance="link"
                >
                    Change Date/Time
                </Button>
            </div>
        </Stack>
    );
}

Details.propTypes = {
    date: PropTypes.string,
    endDate: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    validDays: PropTypes.number,
    onModifyClick: PropTypes.func,
};

Details.defaultProps = {
    validDays: 0,
};
